module.exports = "<h5>Resgate</h5>"